import { z } from "zod";

export const registerDeviceTokenSchema = z.object({
  platform: z.enum(["android", "ios", "web"]),
  token: z.string().min(1).max(4096),
});

export type RegisterDeviceTokenBody = z.infer<
  typeof registerDeviceTokenSchema
>;
